module.exports = __webpack_public_path__ + "static/ww-149ae311e830b6872255983455824585.jpg";